import React from 'react';
import { componentWithVariants, demoFile, variant } from 'system/demo';
import { WithFeatures } from 'util/testutil';
import { ModDashboardDateTime } from '../datetime';

demoFile('open-modules/zdf/component/moddashboard/datetime');

const timestamp = Date.UTC(2023, 0, 2, 15, 0, 0);

function DateTimeDemo({ language }: { language: string }) {
    return (
        <WithFeatures language={language}>
            <ModDashboardDateTime timestamp={timestamp} />
        </WithFeatures>
    );
}

componentWithVariants('ModDashboardDateTime', DateTimeDemo, {}, [
    variant('English', { args: { language: 'english' } }),
    variant('German', { args: { language: 'german' } }),
    variant('French', { args: { language: 'french_canadian' } }),
]);
